export function convertToUrl(str: string): string {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replaceAll("_", "-")
        .replaceAll(" ", "-")
        .replaceAll("'", "-")
        .replaceAll("!", "")
        .replaceAll("?", "")
        .replaceAll(".", "-")
        .replaceAll("œ", "oe")
        .replace(/^-+/g, "")
        .replace(/-+$/g, "")
        ;
}